import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "./firebase";

function SubmissionFeedback() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [submission, setSubmission] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSubmission = async () => {
      try {
        const docRef = doc(db, "submissions", id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setSubmission(docSnap.data());
        } else {
          console.warn("Submission not found");
        }
      } catch (err) {
        console.error("Error fetching submission:", err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchSubmission();
  }, [id]);

  if (loading) return <p>Loading...</p>;
  if (!submission) return <p>Submission not found.</p>;

  return (
    <div style={{ padding: "20px", maxWidth: "700px", margin: "auto" }}>
      <h2>Submission Results</h2>

      <button
        onClick={() => navigate("/orders")}
        style={{
          margin: "10px 0 20px 0",
          padding: "10px 20px",
          backgroundColor: "#1976d2",
          color: "#fff",
          border: "none",
          borderRadius: "5px",
          fontWeight: "bold",
          cursor: "pointer",
        }}
      >
        Back to Orders
      </button>

      <p><strong>Card Name:</strong> {submission.cardName}</p>
      <p><strong>Submission ID:</strong> {id}</p>
      <p><strong>Status:</strong> {submission.status}</p>

      {submission.reviews?.length > 0 ? (
        submission.reviews.map((review, i) => (
          <div
            key={i}
            style={{
              border: "1px solid #ccc",
              padding: "16px",
              marginTop: "16px",
              borderRadius: "8px"
            }}
          >
            <h3>Review {i + 1}</h3>
            <p><strong>Grader:</strong> {review.grader}</p>
            <p><strong>Anticipated Grade:</strong> {review.anticipatedGrade}</p>
            <p><strong>Ceiling Grade:</strong> {review.ceilingGrade}</p>
            <p><strong>Centering - Front:</strong> {review.centeringFront}</p>
            <p><strong>Centering - Back:</strong> {review.centeringBack}</p>
            <p><strong>Raw Value:</strong> ${review.rawValue}</p>
            <p><strong>Anticipated Graded Value:</strong> ${review.gradedValue}</p>
            <p><strong>Explanation:</strong> {review.explanation}</p>
          </div>
        ))
      ) : (
        <p>No reviews yet.</p>
      )}
    </div>
  );
}

export default SubmissionFeedback;
